export const countryCityConstants = {
 
    ADD_CITY_REQUEST: 'ADD_CITY_REQUEST',
    ADD_CITY_SUCCESS: 'ADD_CITY_SUCCESS',
    ADD_CITY_FAILURE: 'ADD_CITY_FAILURE',
    FETCH_STATE_REQUEST: 'FETCH_STATE_REQUEST',
    FETCH_STATE_SUCCESS: 'FETCH_STATE_SUCCESS',
    FETCH_STATE_FAILURE: 'FETCH_STATE_FAILURE',
    FETCH_CITIES_REQUEST: 'FETCH_CITIES_REQUEST',
    FETCH_CITIES_SUCCESS: 'FETCH_CITIES_SUCCESS',
    FETCH_CITIES_FAILURE: 'FETCH_CITIES_FAILURE',
    DELETE_CITY_REQUEST: 'DELETE_CITY_REQUEST',
    DELETE_CITY_SUCCESS: 'DELETE_CITY_SUCCESS',
    DELETE_CITY_FAILURE: 'DELETE_CITY_FAILURE',
    GET_CITY_DETAILS_REQUEST: 'GET_CITY_DETAILS_REQUEST',
    GET_CITY_DETAILS_SUCCESS: 'GET_CITY_DETAILS_SUCCESS',
    GET_CITY_DETAILS_FAILURE:'GET_CITY_DETAILS_FAILURE',
    GET_CITY_DETAILS_BYSTATE_REQUEST: 'GET_CITY_DETAILS_BYSTATE_REQUEST',
    GET_CITY_DETAILS_BYSTATE_SUCCESS: 'GET_CITY_DETAILS_BYSTATE_SUCCESS',
    GET_CITY_DETAILS_BYSTATE_FAILURE:'GET_CITY_DETAILS_BYSTATE_FAILURE',
    FETCH_COUNTRIES_REQUEST:'FETCH_COUNTRIES_REQUEST',
    FETCH_COUNTRIES_SUCCESS : 'FETCH_COUNTRIES_SUCCESS',
    FETCH_COUNTRIES_FAILURE : 'FETCH_COUNTRIES_FAILURE',
    UPDATE_CITY_REQUEST:'UPDATE_CITY_REQUEST',
    UPDATE_CITY_SUCCESS:'UPDATE_CITY_SUCCESS',
    UPDATE_CITY_FAILURE:'UPDATE_CITY_FAILURE',
    FETCH_TIMEZONE_REQUEST:'FETCH_TIMEZONE_REQUEST',
    FETCH_TIMEZONE_SUCCESS:'FETCH_TIMEZONE_SUCCESS',
    FETCH_TIMEZONE_FAILURE:'FETCH_TIMEZONE_FAILURE'
   
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/countryCityConstants.js